// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8544) return "static/chunks/8544-0329306000138ccb.js";
	if (chunkId === 5599) return "static/chunks/5599-8cf889356f338a13.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2207":"01d91ed92291bc66","8503":"30bc11a20e86918f"}[chunkId] + ".js";
};